/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'rc-time-picker/assets/index.css';
import _ from 'lodash';
import List from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import {
  settings,
  SAVE_BUTTON_TEXT,
  MAX_SLOT_INTERVAL,
  MIN_SLOT_INTERVAL,
  UNIT
} from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Spinner from '../Spinner';
import Button from '../Button';
import BackButton from '../BackButton';
import * as actions from '../../actions/index';
import Switch from '../Switch';
import {
  handleSubmitData,
  initDataConfig,
  handleChangeSlotInterval,
  checkMinMaxValue,
  handleToggle
} from './OrderSettings.services';
import { styles } from './OrderSettings.styles';

const ListItem = withStyles({
  root: {
    paddingLeft: '0px',
    paddingBottom: '5px',
    paddingTop: '0px',
    paddingRight: '0px'
  }
})(MuiListItem);
const INITIAL_STATE = {
  data: {},
  isLoading: false
};
class OrderSettings extends Component {
  state = INITIAL_STATE;

  componentWillMount() {
    initDataConfig(this.props, this);
  }

  componentDidUpdate(prevProps) {
    const { hours: oldHours = {}, fleet: oldFleet = {}, autoAccept: oldAutoAccept, isAllShops: oldIsAllShops, shopId: oldShopId } = prevProps;
    const { hours = {}, fleet = {}, autoAccept = {}, isAllShops, shopId } = this.props;
    const { slotInterval: oldSlotInterval } = oldHours;
    const { slotInterval } = hours;
    const { showOrderInPreparation: oldShowOrderInPreparation = false } = oldFleet;
    const { showOrderInPreparation = false } = fleet;

    if ((!_.isEqual(isAllShops, oldIsAllShops) ||
      (isAllShops && (!_.isEqual(slotInterval, oldSlotInterval) ||
        !_.isEqual(showOrderInPreparation, oldShowOrderInPreparation))) ||
      (!isAllShops && (!_.isEqual(autoAccept, oldAutoAccept) || !_.isEqual(shopId, oldShopId)))
    ))
      initDataConfig(this.props, this);
  }

  renderTimeInterval = (isAllShops) => {
    const { classes, nbShops } = this.props;
    const { data } = this.state;
    const { slotInterval, preparationTime } = data;

    return (
      <div className={`row m-0 py-3 ${(!isAllShops || nbShops === 1) && classes.root}`}>
        <div className='col-sm-8'>
          <p className={`col-sm-12 mt-2  ${classes.boldText}`}>{isAllShops ? 'Créneau des commandes' : 'Temps de préparation'}</p>
          <p className={`col-sm-12 mt-2 ${classes.headerFee}`}>
            {!isAllShops &&
              `Lors de l'acceptation automatique, ce temps sera automatiquement défini pour le consommateur.`}
          </p>
        </div>
        <div className='d-flex flex-column col-sm-4'>
          <Input
            margin='dense'
            label={isAllShops ? 'Créneau' : 'Temps'}
            id='slotInterval'
            type='number'
            fullWidth
            value={isAllShops ? slotInterval : preparationTime}
            classes={{ input: classes.underlineInput }}
            onBlur={e => {
              isAllShops && checkMinMaxValue(e, this, MIN_SLOT_INTERVAL, MAX_SLOT_INTERVAL);
            }}
            onChange={event => handleChangeSlotInterval(event, this, isAllShops)}
            InputProps={{
              endAdornment: <InputAdornment position='end'>min</InputAdornment>
            }}
          />
        </div>
      </div>
    );
  };


  renderSwitch = (isAllShops) => {
    const { classes } = this.props;
    const { data = {} } = this.state;
    const { showOrderInPreparation = false, enabled = false } = data;
    return (
      <List className={`${isAllShops && classes.root}`}>
        <ListItem style={{ width: `${UNIT * 5}%` }}>
          <ListItemText className='row m-0 p-3'>
            <p className={`col-sm-12 mt-2 ${classes.boldText}`}>
              {isAllShops ? 'Envoi automatique aux livreurs :' : 'Acceptation automatique des commandes :'}
            </p>
            <p className={`col-sm-12 mt-2 ${classes.headerFee}`}>
              {isAllShops ?
                (showOrderInPreparation ? 'Désactiver' : 'Activer') + ` l'envoi automatique des commandes aux livreurs`
                :
                'Si vous activez cette fonctionnalité, toutes les nouvelles commandes seront automatiquement acceptées et passées en préparation.'
              }
            </p>
          </ListItemText>
          <ListItemSecondaryAction style={{ right: UNIT * 1.25 }}>
            <Switch
              onChange={event => handleToggle(event, this, isAllShops)}
              checked={isAllShops ? showOrderInPreparation : enabled}
              color='primary'
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    );
  };

  render() {
    const { classes, history = {}, isAllShops, nbShops } = this.props;

    const { isLoading } = this.state;
    return (
      <div className='p-4'>
        <BackButton
          className='p-0'
          onClick={() => history.goBack()}
          title={settings.orderSettings.text}
          subtitle={isAllShops ? settings.orderSettings.description.replace('.', ' de tous les magasins.') : settings.orderSettings.description}
        />

        <Paper className={`col-12 px-0 my-3 ${classes.paperStyle}`}>
          {isAllShops ? [this.renderTimeInterval(isAllShops), this.renderSwitch(isAllShops)] : [this.renderSwitch(isAllShops), this.renderTimeInterval(isAllShops)]}
          {nbShops === 1 && [this.renderSwitch(true), this.renderTimeInterval(true)]}
          <div className='d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4'>
            <div className={`px-sm-${isLoading ? 5 : 0} `}>
              {isLoading ? (
                <Spinner size={30} />
              ) : (
                <Button
                  color='primary'
                  onClick={e => handleSubmitData(e, this, isAllShops)}
                  className='btn-primary'
                >
                  <div className='row justify-content-center align-items-center mr-0 ml-0'>
                    <p className='mx-0'>{SAVE_BUTTON_TEXT}</p>
                  </div>
                </Button>
              )}
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}
function mapStateToProps({ firebaseRealTime, user }) {
  const { generalConfig = {}, shop = {} } = firebaseRealTime;
  const { isAllShops, shopId, nbShops } = user
  const { hours = {}, delivery = {} } = generalConfig;
  const { fleet = {} } = delivery;
  const { configuration = {} } = shop;
  const { autoAccept = {} } = configuration;
  return {
    hours,
    fleet,
    isAllShops,
    autoAccept,
    shopId,
    nbShops
  };
}
OrderSettings.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(OrderSettings)));
